import React, { useDispatch, useSelector } from 'react-redux';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import CitySelectContainer from '~/src/components/CitySelectContainer';
import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import selectProviderId from '~/src/store/selectors/selectProviderId';

import DealerFormBlock from './sections/DealerFormBlock';
import HassleCare from './sections/HassleCare';
import Header from './sections/Header';
import HowItWork from './sections/HowItWork';
import Questions from './sections/QuestionsBlock';

import * as ST from './styled';

export interface IDealersData {
    id: number,
    city_id: number,
    dealers_compensation: number,

    [key: string]: unknown,
}

interface IProps {
    city: ICurrentCity,
    dealersData: IDealersData,
}

const ManiaLayout = ({ city, dealersData }: IProps): JSX.Element => {
    const { dealers_compensation } = dealersData;

    const dispatch = useDispatch();

    const providerId = useSelector(selectProviderId);

    const openCitySelectHandler = () => dispatch(openCitySelect());

    return (
        <ST.PageWrapper>
            <Header
                city={city}
                dealersReward={dealers_compensation}
                openCitySelect={openCitySelectHandler}
                data-test='mania-header'
                providerId={providerId}
            />
            <HowItWork/>
            <HassleCare/>
            <DealerFormBlock/>
            <Questions/>
            <CitySelectContainer/>
        </ST.PageWrapper>
    );
};

export default ManiaLayout;
